import { useState } from 'react';

const faqs = [
  {
    question: '如何判断一个视频网站是否安全可靠？',
    answer: '可以从以下方面判断：检查是否使用HTTPS加密、查看网站是否有完整的备案信息、搜索该网站的用户评价和口碑、观察页面是否存在大量弹窗广告。正规网站通常界面规范、信息完整。',
  },
  {
    question: '下载的视频文件有病毒怎么办？',
    answer: '首先不要打开该文件，使用杀毒软件进行扫描。如果确认是恶意文件，立即删除。同时检查设备是否有异常行为，如有需要请恢复出厂设置。建议以后只从可信来源下载文件。',
  },
  {
    question: '个人信息被泄露了如何处理？',
    answer: '立即修改相关账户密码，开启双重认证。向相关平台举报并要求删除泄露信息。如涉及财产损失，及时报警并保留证据。定期查询个人信用报告，防止身份盗用。',
  },
  {
    question: '如何辨别正版APP与盗版APP？',
    answer: '从官方应用商店下载、检查应用包名和数字签名、对比界面和功能是否与官方描述一致。盗版APP通常功能残缺、含有大量广告、要求过多敏感权限。',
  },
  {
    question: '遇到诱导付费该怎么办？',
    answer: '停止继续支付，保存聊天记录和支付凭证作为证据。联系支付平台申请退款，同时向12315或网信办进行投诉举报。金额较大时向公安机关报案。',
  },
  {
    question: '如何有效清除浏览痕迹保护隐私？',
    answer: '在浏览器中清除历史记录、Cookie和缓存文件。使用隐私模式或无痕模式浏览。定期清理设备中的临时文件和应用缓存。对于敏感操作，建议使用虚拟机或沙箱环境。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <script type="application/ld+json">{JSON.stringify(faqLd)}</script>
      <div className="mb-6">
        <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900">常见问题</h2>
        <p className="text-sm text-foreground-500 mt-2">为您整理最常见的安全咨询问题及解答</p>
      </div>
      <div className="max-w-3xl space-y-3">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden"
          >
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left cursor-pointer"
            >
              <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                {faq.question}
              </span>
              <span className={`w-6 h-6 flex items-center justify-center shrink-0 text-foreground-500 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`}>
                <i className="ri-arrow-down-s-line text-lg"></i>
              </span>
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                openIndex === index ? 'max-h-96 pb-4 md:pb-5 px-4 md:px-5' : 'max-h-0'
              }`}
            >
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed border-t border-background-200/70 pt-4">
                {faq.answer}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}